import { useStaticQuery, graphql } from 'gatsby'

import { Program, CircleOffer, SafireCourse } from '@src/types'
import { Nodes } from '@src/types/graphql'

type PartialProgram = Pick<
  Program,
  'id' | 'slug' | 'title' | 'durationText' | 'programType' | 'safireId' | 'shortDescription'
>

type PartialCircle = Pick<
  CircleOffer,
  'safireId' | 'title' | 'ideator' | 'startDate' | 'shortDescription' | 'durationText'
> & {
  course: Pick<SafireCourse, 'MetaDescription' | 'fields'> | null
}

type NavigationProgramsTabQueryResult = {
  programs: Nodes<PartialProgram>
  microprograms: Nodes<PartialProgram>
  circles: Nodes<PartialCircle>
}

export type NavigationProgramsTabData = {
  programs: PartialProgram[]
  microprograms: PartialProgram[]
  circles: PartialCircle[]
}

export default function useNavigationProgramsTabData() {
  const data = useStaticQuery<NavigationProgramsTabQueryResult>(
    graphql`
      {
        programs: allSanityProgram(
          filter: {
            active: { eq: true }
            programType: { eq: "program" }
            showInNavigation: { eq: true }
          }
        ) {
          nodes {
            id
            slug {
              fr {
                current
              }
              en {
                current
              }
            }
            title {
              fr
              en
            }
            durationText {
              fr
              en
            }
            shortDescription {
              fr
              en
            }
            safireId
            programType
          }
        }
        microprograms: allSanityProgram(
          filter: {
            active: { eq: true }
            programType: { eq: "microprogram" }
            showInNavigation: { eq: true }
          }
        ) {
          nodes {
            id
            slug {
              fr {
                current
              }
              en {
                current
              }
            }
            title {
              fr
              en
            }
            durationText {
              fr
              en
            }
            shortDescription {
              fr
              en
            }
            safireId
            programType
          }
        }
        circles: allSanityCircle(filter: { active: { eq: true }, showInNavigation: { eq: true } }) {
          nodes {
            id
            order
            safireId
            startDate
            title {
              fr
              en
            }
            dateLabel {
              fr
              en
            }
            shortDescription {
              fr
              en
            }
            durationText {
              fr
              en
            }
            course {
              MetaDescription {
                fr
                en
              }
              fields {
                url_fr
                url_en
              }
            }
          }
        }
      }
    `
  )

  return {
    programs: data.programs.nodes,
    microprograms: data.microprograms.nodes,
    circles: data.circles.nodes,
  } as NavigationProgramsTabData
}
